export const SET_CREATE_COMPANY = 'SET_CREATE_COMPANY'
export const SEARCH_COMPANY = 'SEARCH_COMPANY'
export const SET_COMPANY_SEARCH_CRITERIA = 'SET_COMPANY_SEARCH_CRITERIA'
export const SET_COMPANY_DETAILS = 'SET_COMPANY_DETAILS'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const FETCH_COMPANIES = 'FETCH_COMPANIES'
